import React, { memo, useMemo } from "react";
import { useCineProState } from "./hooks/useCineProState";
import CineProHeader from "./CineProHeader";
import ModuleSection from "./ModuleSection";
import VideoPlayer from "./VideoPlayer";
import RefreshButton from "./RefreshButton";

// Memoization du ModuleSection pour éviter des re-renders inutiles
const MemoizedModuleSection = memo(ModuleSection);

const CinePro: React.FC = () => {
  const {
    modules,
    loading,
    error,
    selectedModuleId,
    progressData,
    moduleProgressData,
    isRefreshing,
    lastSync,
    selectedVideo,
    handleRefresh,
    handleModuleClick,
    openVideo,
    closeVideo,
  } = useCineProState();

  // Utilisation de useMemo pour éviter de recalculer le rendu des modules à chaque render
  const moduleSections = useMemo(() => {
    if (!Array.isArray(modules)) return null;

    return modules.map((module, moduleIndex) => (
      <MemoizedModuleSection
        key={module.id}
        module={module}
        moduleIndex={moduleIndex}
        progressData={progressData}
        moduleProgressData={moduleProgressData}
        selectedModuleId={selectedModuleId}
        handleModuleClick={handleModuleClick}
        openVideo={openVideo}
      />
    ));
  }, [
    modules,
    progressData,
    moduleProgressData,
    selectedModuleId,
    handleModuleClick,
    openVideo,
  ]);

  return (
    <>
      <CineProHeader />

      {/* Bouton de rafraîchissement flottant */}
      <RefreshButton
        isRefreshing={isRefreshing}
        lastSync={lastSync}
        handleRefresh={handleRefresh}
      />

      <div className="container mx-auto px-4 py-8">
        {loading && !selectedModuleId ? (
          <div className="text-center py-8">
            <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-orange-600 border-r-transparent"></div>
            <p className="mt-2 text-gray-600">Chargement des modules...</p>
          </div>
        ) : error ? (
          <div className="bg-red-50 border border-red-200 text-red-800 p-4 rounded-md">
            {error instanceof Error ? error.message : String(error)}
          </div>
        ) : (
          // Utiliser les modules mémorisés
          moduleSections
        )}
      </div>

      {/* Modal de lecture vidéo */}
      {selectedVideo && (
        <VideoPlayer
          selectedVideo={selectedVideo}
          modules={modules}
          closeVideo={closeVideo}
          onProgressUpdate={handleRefresh}
        />
      )}
    </>
  );
};

export default CinePro;
